'use client';
import { CloudinaryType, TypeBlockLogoCarousel } from '@fm-nx/contentful-types';
import { richTextRender } from '@fm-nx/rich-text';
import ClientLogo from '../client-logo/client-logo';
import AnimationFadeLazy from '../animation-fade-lazy/animation-fade-lazy';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type BlockLogoCarouselPropTypes = {
    blockLogoCarousel: TypeBlockLogoCarousel<'WITHOUT_UNRESOLVABLE_LINKS'>;
};

export const BlockLogoCarousel = (props: BlockLogoCarouselPropTypes) => {
    const { blockLogoCarousel } = props;
    const { fields } = blockLogoCarousel;
    if (!fields) return null;

    const { title, intro, logosCloudinary } = fields;

    if (!title || !intro || !Array.isArray(logosCloudinary)) return null;

    const logoCount = logosCloudinary.length;

    const settings = {
        dots: false,
        infinite: logoCount > 5,
        speed: 500,
        centerMode: true,
        centerPadding: '10%',
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: logoCount > 5,
        autoplaySpeed: 2000,
        arrows: false,
        swipeToSlide: true,
        touchThreshold: 10,
        cssEase: 'ease-in-out',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    centerPadding: '8%',
                    infinite: logoCount > 4,
                    autoplay: logoCount > 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '10%',
                    infinite: logoCount > 3,
                    autoplay: logoCount > 3,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '12%',
                    infinite: logoCount > 2,
                    autoplay: logoCount > 2,
                },
            },
        ],
    };

    return (
        <AnimationFadeLazy>
            <div className="w-full mx-auto max-w-container">
                <div className="pt-20 mx-6 md:mx-0">
                    <div className="max-w-2xl mx-auto mb-12 text-center">
                        <h3 className="mb-4 text-3xl font-bold leading-tight md:text-4xl">{title}</h3>
                        <div className="text-lg leading-relaxed text-gray-600 md:text-xl">{richTextRender(intro)}</div>
                    </div>
                </div>
            </div>

            <div className="w-full pb-20 overflow-hidden">
                <Slider {...settings}>
                    {(logosCloudinary as CloudinaryType[]).map((logo) => {
                        if (!logo) return null;
                        return (
                            <div key={logo.public_id}>
                                <div className="flex items-center justify-center h-[144px] px-8">
                                    <div className="flex items-center justify-center h-12">
                                        <ClientLogo image={logo} mode="black" />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>
        </AnimationFadeLazy>
    );
};

export default BlockLogoCarousel;
